document.querySelectorAll('.multi-tab-section').forEach(function (section) {
  var tabs = section.querySelectorAll('.multi-tab-section__tab');
  var panels = section.querySelectorAll('.multi-tab-section__panel');

  tabs.forEach(function (tab) {
    tab.addEventListener('click', function () {
      var index = tab.getAttribute('data-tab-index');

      tabs.forEach(function (t) {
        var isActive = t === tab;
        t.classList.toggle('is-active', isActive);
        t.setAttribute('aria-selected', isActive ? 'true' : 'false');
      });

      panels.forEach(function (panel) {
        var isActive = panel.getAttribute('data-tab-panel') === index;
        panel.classList.toggle('is-active', isActive);
        if (isActive) {
          panel.removeAttribute('hidden');
        } else {
          panel.setAttribute('hidden', '');
        }
      });
    });
  });
});